import { FC } from 'react';
import { FormikProps } from 'formik';
import { SelectInput } from 'components/core';
import TextArea from 'components/core/text-area';

interface RequestDetailsStepProps {
  form: FormikProps<{
    category: string;
    details: string;
    assigneeType: 'group' | 'user';
    assigneeId: number;
    assigneeName: string;
  }>;
}

const categoryOptions = [
  { value: 'hardware', label: 'Hardware' },
  { value: 'system_access', label: 'System Access' },
  { value: 'software', label: 'Software' },
  { value: 'email', label: 'Email Account' },
  { value: 'communication', label: 'Communication Tools' },
  { value: 'training', label: 'Training Access' },
  { value: 'other', label: 'Other' },
];

const RequestDetailsStep: FC<RequestDetailsStepProps> = ({ form }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-6">
        <div>
          <SelectInput
            id="category"
            label="Request Category"
            placeholder="Select a category"
            required={true}
            options={categoryOptions}
            {...form}
          />
        </div>
        <div>
          <TextArea
            id="details"
            label="Request Details"
            placeholder="Describe what you need in detail. For example: Create an email and slack account for new employee John Doe in the Marketing department."
            required={true}
            rows={6}
            {...form}
          />
          <p className="mt-2 text-sm text-gray-500">
            Please provide as much detail as possible to help the assignee understand and fulfill your request.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RequestDetailsStep;
